
import { IRegion } from './region';


export interface IPovertyLevel {
  readonly id: number;
  regionId?: number;
  region?: IRegion;
  modifyDate?: Date | string;
  povertyGuideline?: number;
  minimumPersons?: number;
  state?: string;
}
